import { createSlice } from "@reduxjs/toolkit";
import { ARCHIVE_STATUS_ENTITY_TYPES } from "constants/archiveStatuses";

const emptyEntityState = () => ({
  statuses: [],
  editableStatuses: [],
  isEditing: false,
  isDirty: false,
  isLoading: false,
  isLocked: false,
  lockedBy: "",
});

const initialState = Object.fromEntries(
  Object.values(ARCHIVE_STATUS_ENTITY_TYPES).map((entityType) => [
    entityType,
    emptyEntityState(),
  ])
);

export const archiveStatusesSlice = createSlice({
  name: "archiveStatuses",
  initialState,
  reducers: {
    setStatuses(state, { payload }) {
      const { entityType, statuses = [] } = payload;
      state[entityType].statuses = statuses;
    },
    setEditableStatuses(state, { payload }) {
      const { entityType, statuses = [] } = payload;
      state[entityType].editableStatuses = statuses;
    },
    addStatus(state, { payload }) {
      const { entityType, status, index } = payload;
      const entityState = state[entityType];
      entityState.isDirty = true;
      entityState.editableStatuses = [
        ...entityState.editableStatuses.slice(0, index + 1),
        status,
        ...entityState.editableStatuses.slice(index + 1),
      ];
    },
    updateStatus(state, { payload }) {
      const { entityType, index, changes } = payload;
      const entityState = state[entityType];
      entityState.isDirty = true;
      entityState.editableStatuses = entityState.editableStatuses.map(
        (status, i) => (i === index ? { ...status, ...changes } : status)
      );
    },
    removeStatus(state, { payload }) {
      const { entityType, index } = payload;
      const entityState = state[entityType];
      entityState.isDirty = true;
      entityState.editableStatuses = entityState.editableStatuses.filter(
        (_, i) => i !== index
      );
    },
    setIsEditing(state, { payload }) {
      state[payload.entityType].isEditing = Boolean(payload.isEditing);
    },
    setIsDirty(state, { payload }) {
      state[payload.entityType].isDirty = Boolean(payload.isDirty);
    },
    setIsLoading(state, { payload }) {
      state[payload.entityType].isLoading = Boolean(payload.isLoading);
    },
    setIsLocked(state, { payload }) {
      state[payload.entityType].isLocked = Boolean(payload.isLocked);
    },
    setLockedBy(state, { payload }) {
      state[payload.entityType].lockedBy = payload.lockedBy;
    },
  },
});

export const {
  setStatuses,
  setEditableStatuses,
  addStatus,
  updateStatus,
  removeStatus,
  setIsEditing,
  setIsDirty,
  setIsLoading,
  setIsLocked,
  setLockedBy,
} = archiveStatusesSlice.actions;

export default archiveStatusesSlice.reducer;
